import React from "react";
import { Switch, Route } from "react-router-dom";

// components

import Sidebar from "components/Sidebar/Sidebar.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// contexts
import { SidebarProvider, useSidebar } from "contexts/SidebarContext.js";
import { NotificationProvider } from "contexts/NotificationContext.js";

// views

import Dashboard from "views/admin/Dashboard.js";
import Tables from "views/admin/Tables.js";
import Projects from "views/admin/Projects.js";
import Plans from "views/admin/Plans.js";
import Users from "views/admin/Users.js";
import Leads from "views/admin/Leads.js";
import AiModels from "views/admin/AiModels.js";
import Credits from "views/admin/Credits.js";
import CreditAnalytics from "views/admin/CreditAnalytics.js";

function AdminContent() {
  const { isCollapsed } = useSidebar();
  
  return (
    <>
      <Sidebar />
      <div className={`relative bg-blueGray-100 transition-all duration-300 ${
        isCollapsed ? 'md:ml-16' : 'md:ml-64'
      }`}>
        <div className="px-4 md:px-10 mx-auto w-full pt-6">
          <Switch>
            <Route path="/dashboard" exact component={Dashboard} />
            <Route path="/tasks" exact component={Tables} />
            <Route path="/projects" exact component={Projects} />
            <Route path="/plans" exact component={Plans} />
            <Route path="/users" exact component={Users} />
            <Route path="/leads" exact component={Leads} />
            <Route path="/ai-models" exact component={AiModels} />
            <Route path="/credits" exact component={Credits} />
            <Route path="/credit-analytics" exact component={CreditAnalytics} />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}

export default function Admin() {
  return (
    <NotificationProvider>
      <SidebarProvider>
        <AdminContent />
      </SidebarProvider>
    </NotificationProvider>
  );
}
